import {ArenaFiltersConfigurationMap, IArenaViewModel} from "../arena-view-model.interface";
import {GameInfo} from "../../../../games/game-info";
import {IGamesFilterStrategy} from "../../../../games-filter/strategies/games-filter-strategy.interface";
import {VIDEO_SLIDES_ARENA} from "../../../arena-consts";
import {VideoSlidesArena} from "../../../../../components/arena-host/video-slides-arena/video-slides-arena.component";
import {UserMenu} from "../../../../../components/user-menu/user-menu.component";
import React from "react";
import {IServiceFactoryExtended} from "../../../../service-factory-extended.interface";
import {RightDrawerComponent} from "../../../../../components/drawer/drawer.component";
import {CyClass} from "../../../../../../common/cy-classes";
import {AdvancedGamesFilterStrategy} from "../../../../games-filter/strategies/advanced-filter/advanced-games-filter.strategy";


export default class VideoSlidesArenaModel implements IArenaViewModel {
    constructor(private readonly services: IServiceFactoryExtended) {
    }

    readonly filteredGamesCount: number;
    readonly filtersConfigurationMap: ArenaFiltersConfigurationMap;
    readonly listsCount: number;
    maxGamesToShowInList: number;

    get allArenaGamesForFiltering(): GameInfo[] {
        return this.services.videoSlides.allGamesInArena;
    }

    readonly arenaName: string = VIDEO_SLIDES_ARENA;


    filterGamesByArenaType(gamesInfo: GameInfo[]): GameInfo[] {
        return [];
    }

    getGamesFilteringStrategy(): IGamesFilterStrategy {
        return new AdvancedGamesFilterStrategy(this.services);
    }

    getNextBatchSize(currentListPosition: number): number {
        return 0;
    }

    renderArena(): React.ReactElement | null {
        return (
            <>
                <VideoSlidesArena />
                <UserMenu />
                <RightDrawerComponent key="right-drawer" className={CyClass('cy-right-drawer')} />
            </>
        );
    }

    renderList(listPosition: number): React.ReactElement | null {
        return undefined;
    }

}